import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';

import {
  TPersonNegativation,
  TPersonNegativationHistory,
} from '../entities/person-negativation.model';

/**
 * Endpoints de negativação do `PersonController`.
 *
 * A marcação NÃO trafega pelo PATCH da ficha — foi decisão do backend, para que
 * quem pode editar o cadastro não marque clientes sem ter a permissão 291.
 */
@Injectable({ providedIn: 'root' })
export class PersonNegativationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.personService;

  /** Cliente nunca marcado responde `IsNegativated: false` com o resto nulo — não dá 404. */
  public getNegativation(personId: string): Observable<TPersonNegativation> {
    return this.http.get<TPersonNegativation>(
      `${this.baseUrl}/Person/${personId}/negativation`,
      { withCredentials: true }
    );
  }

  /**
   * Ativa a marcação ou altera só a observação de quem já está marcado.
   * `Note` é opcional e aceita texto longo com quebras de linha.
   */
  public setNegativation(
    personId: string,
    note: string | null
  ): Observable<TPersonNegativation> {
    return this.http.put<TPersonNegativation>(
      `${this.baseUrl}/Person/${personId}/negativation`,
      { Note: note },
      { withCredentials: true }
    );
  }

  /** Idempotente: sobre cliente não marcado é no-op. */
  public removeNegativation(personId: string): Observable<TPersonNegativation> {
    return this.http.delete<TPersonNegativation>(
      `${this.baseUrl}/Person/${personId}/negativation`,
      { withCredentials: true }
    );
  }

  /** Mais recente primeiro. Sobrevive à remoção da marcação. */
  public getHistory(
    personId: string
  ): Observable<TPersonNegativationHistory[]> {
    return this.http.get<TPersonNegativationHistory[]>(
      `${this.baseUrl}/Person/${personId}/negativation/history`,
      { withCredentials: true }
    );
  }
}
